import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../models/api-client.js';
import { queryKeys } from '../models/query-keys.js';
import { useSession } from './session-context.jsx';

export function useBilling() {
  const { setUser, setCancelOpened } = useSession();
  const queryClient = useQueryClient();
  const checkout = useMutation({
    mutationFn: interval => api('/api/stripe/checkout', { body: { interval } }),
    onSuccess: ({ url }) => { window.location.assign(url); },
  });
  const cancel = useMutation({
    mutationFn: () => api('/api/stripe/unsubscribe', { body: {} }),
    onSuccess: user => {
      setUser(user);
      queryClient.invalidateQueries({ queryKey: queryKeys.allAnalytics });
      setCancelOpened(false);
    },
  });
  return { checkout, cancel };
}

export function useCheckoutConfirmation(sessionId) {
  const { setUser } = useSession();
  return useQuery({
    queryKey: queryKeys.checkoutConfirmation(sessionId),
    queryFn: async () => {
      const user = await api('/api/stripe/confirm', { body: { sessionId } });
      setUser(user);
      return user;
    },
    enabled: Boolean(sessionId),
    staleTime: Infinity,
  });
}
